import React from 'react';

import TextArea from '@atlaskit/textarea';
import TextField from '@atlaskit/textfield';

import Field from 'src/views/components/Form/Field';

import ProjectIssueType from './ProjectIssueType';

const CreateIssueFormStateless = ({ values, touched, errors, onChange, onBlur }) => (
  <>
    <ProjectIssueType
      values={values}
      touched={touched}
      errors={errors}
      onChange={onChange}
      onBlur={onBlur}
    />

    <Field label="Summary" isRequired errorMessage={touched.summary && errors.summary}>
      <TextField
        name="summary"
        value={values.summary}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Field>

    <Field label="Description" errorMessage={touched.description && errors.description}>
      <TextArea
        name="description"
        minimumRows={5}
        value={values.description}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Field>
  </>
);

export default CreateIssueFormStateless;
